window.Layout = (function() {
    return {
        mobilebreak: 1023,
        isMobile: function(){
          return $(window).width()<Layout.mobilebreak
        },

        init: function() {
            this.initCarousels();
            this.initVideo();
            this.initModals();
        },

        initCarousels: function() {

            $('.carousel-banner').each(function() {
                Layout.initHomeCarousel($(this));
            });

            $('.design-carousel').each(function() {
                var slides = $(this).data('slides');
                let mobileDots = !($(this).data('mobiledots') == 0);

                let $carousel = $(this).find('.carousel');

                $carousel.slick({
                    slidesToShow: slides,
                    slidesToScroll: 1,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: false,
                                dots: mobileDots,
                            }
                        }
                    ]
                });

                if ($carousel.hasClass('same-height')) {
                    setTimeout(function() {
                        let maxHeight = 0;

                        $carousel.find('.slick-slide').each(function() {
                            if ($(this).find('.holder').height() > maxHeight) {
                                maxHeight = $(this).find('.holder').height();
                            }
                        })

                        $carousel.find('.slick-slide').find('.holder').height(maxHeight);
                    }, 1000)
                }
            })

            $('.projects-carousel').each(function() {
                let slides = $(this).data('slides');
                let mobileDots = !($(this).data('mobiledots') == 0);
                let $carousel = $(this).find('.carousel');

                $carousel.slick({
                    slidesToShow: slides,
                    slidesToScroll: 1,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: mobileDots,
                            }
                        }
                    ]
                });
            })



            $('.content-carousel').each(function() {
                let $carousel = $(this).find('.carousel');
                
                $carousel.slick({
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                dots: true,
                                arrows: false,
                            }
                        }
                    ]
                }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    // ... how to pause an embedded video?
                });

            })


            // folder carousels, init only on mobile
            $(window).on('load resize orientationchange', function() {

                $('.folder-carousel').each(function() {
                    let slides = $(this).data('slides') || 2;

                    let $carousel = $(this) // .find('.carousel');

                    console.log('folder carousel', slides, this);

                    /* Initializes a slick carousel only on mobile screens */
                    // slick on mobile
                    if ($(window).outerWidth() > 1024) {
                        if ($carousel.hasClass('slick-initialized')) {
                            $carousel.slick('unslick');
                        }
                    }
                    else {
                        if (!$carousel.hasClass('slick-initialized')) {
                            $carousel.slick({
                                slidesToShow: slides,
                                slidesToScroll: 1,
                                dots: true,
                                arrows: false,
                                mobileFirst: true,
                            });
                        }
                    }
                });
            });

            $('.slick-prev').each(function() {
                $(this).css('display', '');
            })

        },

        initHomeCarousel:function( $el ){
            // countdown dots
            let $carousel = $el.find('.carousel');
            $carousel.slick({
                dots: true,
                fade: true,
                infinite: true,
                autoplay: false,
                speed: 800,
                arrows: false
            });
            
            $(document).on('carousel.item.video.sound.stop', function(e, param) {
                const $video = $('#' + param.videoID);
                const $audioButton = $video.siblings('#video-volume--' + param.videoID);

                $audioButton.addClass('muted');
                $video.prop('muted', true);
                if (param.pause) {
                    $video[0].pause();
                }
            });
            
            $(document).on('carousel.item.video.sound.play', function(e, param) {
                const $video = $('#' + param.videoID);
                const $audioButton = $video.siblings('#video-volume--' + param.videoID);

                $audioButton.removeClass('muted');
                $video.prop('muted', false);
                $video[0].play();
            });

            $carousel.on('beforeChange', function(event, slick, currentSlide) {
                const $prevVideo = $(this).find('.slick-slide[data-slick-index="'+currentSlide+'"]').find('.video_banner');
                if ($prevVideo.length > 0) {
                    $(document).trigger('carousel.item.video.sound.stop', [{videoID: $prevVideo.attr('id'), pause: true}])
                }
            });

            $carousel.on('afterChange', function(slick, currentSlide) {
                const $currentVideo = $(this).find('.slick-slide.slick-active').find('.video_banner');
                if ($currentVideo.length > 0) {
                    $(document).trigger('carousel.item.video.sound.play', [{videoID: $currentVideo.attr('id')}])
                }
            });
            
        },

        initVideo: function() {
            $('body').on('click', '.js-video-init', function(e) {
                $(this).find('.preview').hide();
                $(this).find('video')[0].setAttribute('controls', 'controls');
                $(this).find('video').trigger('play');
            })
        },
        closeModal: function(selector){
            $('.tw-modal').fadeOut(250);
            $('body').trigger({
                type: 'modal-closed',
                selector: selector
            });
        },
        openModal: function(selector){
            // any sizing or initialization
            $( selector ).fadeIn(200);
        },
        initModals: function(){
            // MODAL TRIGGER ELEMENTS
            $('[data-modal]').on('click', function (e) {
                e.preventDefault();

                if ($(this).attr('data-modal') == '#newsletterModal') {
                    tracking.sendGaEvent('Newsletter Registration', 'Popped Up', 'Newsletter Registration: Modal Popped Up', {
                        'event_location': window.location.href
                    });
                }
                
                Layout.openModal( $(this).data('modal') );
            })
            $('body').on('click', '[data-modal-close]', function (e) {
                e.preventDefault();
                if ( $(this).data('modal-close').length ) {
                    Layout.closeModal( $(this).data('modal-close') );
                } else {
                    Layout.closeModal( e.target );
                }
            })
            // click outside modal to close if not data-static
            $('body').on('click', '.tw-modal-bg', function (e) {
                if (!$(this).data('static')){
                    Layout.closeModal(e.target);
                }
            })

        },


    }
}());

$(document).ready(function () {
  	Layout.init();
    Lightbox.init(); // in lib.js
    accordion();

    // design single sector filter
    $(document).on('change','.check-sector',function(){
        var id= this.id;
        $(".check-sector:not('#"+id+"')").each(function(){
            if($(this).prop("checked") == true)
            {
                $(this).trigger('click');
            }
        });
    });
    
    $(document).on("click",".scrollTo",function(){
        var scrollTo = $(this).attr("data-scrollto");
            $('html, body').animate({
                scrollTop: $(scrollTo).offset().top - 100
            }, 500); return false;
    });

    if (window.innerWidth <= 768) {
        $(".video_banner.video-banner-mobile").hide().delay(1000).fadeIn(1500);
    } else {
        $(".video_banner.video-banner-desktop").hide().delay(1000).fadeIn(1500);
    }

    // $(".video_banner").hide().delay(1000).fadeIn(1500);
});